import { ApiSdk } from '@/httpclient';
import { fileService } from '@/services/fileService';
import { TourGuideAttachment, TourGuideDetailModel } from '@/__generated';
import { DeleteOutlined, DownloadOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, message, Row, Space, Tooltip } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';

type Props = {
  guide?: TourGuideDetailModel | null | undefined;
  onChange?: (v: TourGuideAttachment[]) => void;
  displayForContract?: boolean;
  value?: any;
};
interface FileUploadProps extends TourGuideAttachment {
  isNewFile?: boolean;
}
export default function GuideAttachment({ guide, onChange, value, displayForContract }: Props) {
  const { t } = useTranslation();
  const [files, setFiles] = React.useState<FileUploadProps[]>(guide?.attachmentFiles || value || []);
  let ref = React.useRef<HTMLInputElement>();
  const upload = (uploadFiles: FileList | null) => {
    if (uploadFiles && uploadFiles.length) {
      const file = uploadFiles[0];
      const loader = message.loading(t('Uploading'), 100000);

      ApiSdk.MediaService.uploadFile({ fileName: file.name, formFile: file })
        .then(res => {
          if (res.success) {
            setFiles(f => [
              ...f,
              { id: res.fileId, name: res.fileName, isApartOfGuideContract: f.length ? false : displayForContract, isNewFile: true },
            ]);
          } else {
            message.error(t(res.message || ''));
          }
        })
        .finally(() => {
          if (loader) {
            loader();
          }
        });
    }
    (ref?.current as any)!.value = '';
  };

  const onCheckedChange = (fileId: string) => {
    setFiles(x => {
      let file = x.find(x => x.id === fileId);
      if (file) {
        file.isApartOfGuideContract = !file.isApartOfGuideContract;
      }
      return cloneDeep(x);
    });
  };
  React.useEffect(() => {
    if (onChange) {
      onChange(files || []);
    }
  }, [files]);
  return (
    <Row style={{ marginTop: 10, marginBottom: 10, backgroundColor: '#dddddd80', padding: 10, borderRadius: 10 }}>
      <Col md={3} xs={12}>
        <h3 style={{ fontWeight: 'bold', marginBottom: 0, lineHeight: '32px' }}>{t('Attachment')}</h3>
      </Col>
      <Col md={0} xs={12}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            ref.current?.click();
          }}
        >
          {t('Upload Attachment')}
        </Button>
        <input
          style={{ display: 'none' }}
          ref={ref as any}
          type="file"
          onChange={evt => {
            upload(evt.target.files);
          }}
        />
      </Col>
      <Col md={17} xs={24} style={{ borderLeft: '1px solid #ccc', paddingLeft: 10 }}>
        {files.map(file => {
          return (
            <Row gutter={6} key={file.id} style={{ alignItems: 'center', marginBottom: 5 }}>
              <Col flex={'1 1'} className="truncate">
                <Tooltip title={file.name}>
                  <div className="truncate">{file.name}</div>
                </Tooltip>
              </Col>
              {displayForContract ? (
                <Col flex={'150px'}>
                  <Checkbox onClick={() => onCheckedChange(file.id || '')} checked={file.isApartOfGuideContract}>
                    {t('guideContract_FormContract')}
                  </Checkbox>
                </Col>
              ) : null}

              <Col flex={'100px'}>
                <Space align="end">
                  <Button
                    disabled={file.isNewFile}
                    icon={<DownloadOutlined />}
                    type="default"
                    onClick={() => {
                      fileService.downloadFileById(file.id || '', file.url, file.name);
                    }}
                  />
                  <Button
                    icon={<DeleteOutlined />}
                    danger
                    onClick={() => {
                      setFiles(f => f.filter(x => x.id !== file.id));
                    }}
                  />
                </Space>
              </Col>
            </Row>
          );
        })}
      </Col>

      <Col md={4} xs={0} style={{ textAlign: 'end' }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            ref.current?.click();
          }}
        >
          {t('Upload Attachment')}
        </Button>
        <input
          style={{ display: 'none' }}
          ref={ref as any}
          type="file"
          onChange={evt => {
            upload(evt.target.files);
          }}
        />
      </Col>
    </Row>
  );
}
